export default function SectionHeader({ eyebrow, title, description, align = "left", testid }) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignment}`} data-testid={testid}>
      {eyebrow && (
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-blue-700 mb-4">
          {eyebrow}
        </p>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-slate-900 leading-[1.05]">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{description}</p>
      )}
    </div>
  );
}
